import RatioStatCard from './RatioStatCard';

const AllRoomsRatioStats = ({ ratioData, loading }) => {
	const totalStudents = ratioData?.reduce((acc, item) => acc + item.ratios.student_count, 0);
	const totalStaff = ratioData?.reduce((acc, item) => acc + item.ratios.staff_count, 0);

	const roomsOutOfRatio = ratioData?.filter((room) => {
		if (!room.student_ratio_count || !room.required_staff) {
			return room.ratios.student_count > 2 * room.ratios.staff_count;
		}

		const studentsPerStaff = room.student_ratio_count / room.required_staff;
		const requiredStaff = Math.ceil(room.ratios.student_count / studentsPerStaff);
		return room.ratios.staff_count < requiredStaff;
	}).length;

	return (
		<div className="flex gap-24 justify-between flex-col md:flex-row">
			<RatioStatCard loading={loading} title="Students Checked In" value={totalStudents} />
			<RatioStatCard loading={loading} title="Teachers Checked In" value={totalStaff} />
			<RatioStatCard
				loading={loading}
				title="Live Room Ratios"
				value={roomsOutOfRatio ? `${roomsOutOfRatio} out of ratio` : 'All rooms in ratio'}
			/>
		</div>
	);
};

export default AllRoomsRatioStats;
